import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import api from "../lib/api";

export function BlogListPage() {
  const [posts, setPosts] = useState([]);
  useEffect(() => { api.get("/blog").then(({data}) => setPosts(data)); }, []);
  return (
    <div data-testid="blog-list-page" className="max-w-7xl mx-auto px-6 lg:px-10 py-12">
      <p className="text-xs uppercase tracking-widest text-welljio-subtle">Welljio blog</p>
      <h1 className="font-heading text-5xl sm:text-6xl font-bold tracking-tight mt-3">Stories of comfort, posture and recovery.</h1>
      <div className="grid md:grid-cols-3 gap-6 mt-14">
        {posts.map((p,i) => (
          <Link key={p.slug} to={`/blog/${p.slug}`} className="welljio-card bg-white border border-slate-100 rounded-3xl overflow-hidden" style={{ animationDelay: `${i*80}ms` }}>
            <img src={p.cover_image} alt={p.title} className="welljio-card-image w-full aspect-[16/10] object-cover"/>
            <div className="p-6">
              <p className="text-xs uppercase tracking-widest text-welljio-subtle mb-2">{p.category} · {p.read_time}</p>
              <h2 className="font-heading text-xl font-semibold leading-snug mb-2">{p.title}</h2>
              <p className="text-sm text-welljio-muted line-clamp-2">{p.excerpt}</p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}

export function BlogPostPage() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [notFound, setNotFound] = useState(false);
  useEffect(() => {
    setPost(null);
    setNotFound(false);
    api.get(`/blog/${slug}`)
      .then(({ data }) => setPost(data))
      .catch(() => setNotFound(true));
    window.scrollTo({ top: 0 });
  }, [slug]);
  if (notFound) {
    return (
      <div data-testid="blog-post-not-found" className="max-w-3xl mx-auto px-6 py-20 text-center">
        <p className="text-xs uppercase tracking-widest text-welljio-subtle mb-3">404</p>
        <h1 className="font-heading text-4xl font-bold tracking-tight mb-4">Story not found.</h1>
        <p className="text-welljio-muted mb-8">The post you're looking for isn't here yet — but the rest of our journal is.</p>
        <Link to="/blog" className="inline-block bg-welljio-ink text-white rounded-full px-7 py-3.5 font-medium hover:bg-slate-800">Back to blog</Link>
      </div>
    );
  }
  if (!post) return <div className="max-w-3xl mx-auto px-6 py-20 text-welljio-muted">Loading...</div>;
  return (
    <article data-testid="blog-post-page" className="max-w-3xl mx-auto px-6 py-12">
      <p className="text-xs uppercase tracking-widest text-welljio-subtle mb-3">{post.category} · {post.read_time} · {post.date}</p>
      <h1 className="font-heading text-4xl sm:text-5xl font-bold tracking-tight leading-tight mb-6">{post.title}</h1>
      <img src={post.cover_image} alt={post.title} className="rounded-3xl w-full aspect-[16/9] object-cover my-8"/>
      <p className="text-lg text-welljio-muted leading-relaxed">{post.content}</p>
      <div className="mt-12">
        <Link to="/blog" className="text-welljio-accent hover:underline text-sm">← Back to blog</Link>
      </div>
    </article>
  );
}
